import styled from 'styled-components';
import {Space} from 'antd';
import AntdModal from '../../../../../AntdModal';
import {typographyStyles} from '../../../../../../utils/styles';

const StyledApproveExpenseModal = styled(AntdModal)`
  .ant-modal-content {
    .ant-modal-body {
      padding-top: 40px;

      .ant-space-item {
        display: flex;
      }
    }
  }
`;

const StyledApproveExpenseModalDescription = styled.p`
  ${typographyStyles.heading.h5};

  color: ${props => props.theme.colors.neutral_10};
  text-align: center;

  svg {
    height: 24px;
    width: 24px;

    path {
      fill: ${props => props.theme.colors.primary_6};
    }
  }
`;

const StyledApproveExpenseModalApprovalsSpace = styled(Space)`
  width: 100%;

  & > .ant-space-item {
    align-items: center;
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

export {
  StyledApproveExpenseModal,
  StyledApproveExpenseModalDescription,
  StyledApproveExpenseModalApprovalsSpace,
};
